import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';
import { LABEL_DIMENSIONS_MM } from '../../utils/labelDimensions';
import './ShippingLabel.css';

/**
 * Shipping box label — tuned for browser print to Argox driver (Phase 1).
 */
function ShippingLabel({ order, boxIndex = 1, boxTotal = 1 }) {
  const svgRef = useRef(null);
  const barcodeValue =
    order && order.orderNumber != null ? String(order.orderNumber) : '';

  useEffect(() => {
    if (!svgRef.current || !barcodeValue) return;
    try {
      while (svgRef.current.firstChild) {
        svgRef.current.removeChild(svgRef.current.firstChild);
      }
      JsBarcode(svgRef.current, barcodeValue, {
        format: 'CODE128',
        width: 1.8,
        height: 56,
        displayValue: true,
        fontSize: 14,
        margin: 4,
      });
    } catch (e) {
      console.warn('Barcode render failed', e);
    }
  }, [barcodeValue]);

  if (!order) return null;

  const shipName = order.deliveryname || order.name || '';
  const shipCity = order.deliverycity || order.city || '';
  const shipPost = order.deliverypostCode || order.postCode || '';
  const phone = order.deliveryphone || order.phone || '';

  return (
    <div
      className="shipping-label-root"
      style={{
        '--label-width-mm': LABEL_DIMENSIONS_MM.widthMm,
        '--label-height-mm': LABEL_DIMENSIONS_MM.heightMm,
      }}
    >
      <div className="shipping-label-brand">Sicily To Malta — Ship label</div>
      <div className="shipping-label-order-row">
        <div className="shipping-label-order">Order #{order.orderNumber}</div>
        {boxTotal > 1 ? (
          <div className="shipping-label-box-count">
            {boxIndex}/{boxTotal}
          </div>
        ) : null}
      </div>
      <svg ref={svgRef} className="shipping-label-barcode" aria-hidden />
      <div className="shipping-label-block">
        <div className="shipping-label-strong">{shipName}</div>
        <div>
          {shipCity}
          {shipCity && shipPost ? ', ' : ''}
          {shipPost}
        </div>
        {phone ? <div>Tel {phone}</div> : null}
      </div>
    </div>
  );
}

export default ShippingLabel;
